const initialState = {
  loading: false,
};

export default initialState;
